import React, { useContext, useState } from 'react'
import {CartContext} from "../Context/Cart/CartContext"

const Cart = () => {
  let {state}=useContext(CartContext)
  console.log(state)

  return (
    <>
    {state.map((e)=>{
        return  e.poduct_name
    })}
    </>
  )
}

export default Cart